import { useMutation } from '@tanstack/react-query';

import type { Estate } from '@/features/estates-property/api/estate';
import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type DeleteImageOptions = {
  mutationConfig?: MutationConfig<typeof deleteImage>;
};

type DeleteImage = {
  estateId: Estate['id'];
  imageIds: string[];
};

const deleteImage = ({ estateId, imageIds }: DeleteImage) => {
  return extractData(api.estates({ id: estateId }).images.batch.delete({ imageIds }));
};

export const useDeleteImage = ({ mutationConfig }: DeleteImageOptions = {}) => {
  return useMutation({ ...mutationConfig, mutationFn: deleteImage });
};
